module.exports = __webpack_public_path__ + "static/media/analytics.8c058e47.svg";